export default __webpack_public_path__ + "static/media/AUGDOM2025.1a997dbb.png";